import React from 'react';
import { Home, Search, GraduationCap } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../components/common/Button';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center p-4">
      <div className="text-center max-w-2xl">
        <div className="inline-flex p-4 bg-blue-100 rounded-full mb-8">
          <GraduationCap className="w-16 h-16 text-blue-600" />
        </div>
        
        <h1 className="text-9xl font-bold text-blue-600 mb-4">404</h1>
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h2>
        
        <p className="text-gray-600 mb-8 text-lg">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back to learning!
        </p>
        
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          <Link to="/">
            <Button variant="primary" size="large" icon="Home">
              Back to Home
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" size="large" icon="Search">
              Browse Materials
            </Button>
          </Link>
        </div>
        
        <div className="bg-gray-50 rounded-2xl p-6">
          <h3 className="font-bold text-gray-900 mb-4">Quick Links</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <a href="#" className="p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="text-blue-600 font-medium">Browse Schools</div>
            </a>
            <a href="#" className="p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="text-blue-600 font-medium">Search Materials</div>
            </a>
            <a href="#" className="p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="text-blue-600 font-medium">Teacher Login</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;